import { CompanyDetails } from './CompanyDetails'
import s from './LinkedCompanySection.scss'

const LinkedCompanySection = ({ parent, subsidiaryCompanies }) => {
  return (
    <section className={s.container}>
      {parent && (
        <>
          <div className={s.title}>Parent Company</div>
          <div className={s.details}>
            <CompanyDetails company={parent} />
          </div>
        </>
      )}
      {!!subsidiaryCompanies.length && (
        <>
          <div className={s.title}>Subsidiary Company</div>
          {subsidiaryCompanies.map(company => (
            <div key={company.id} className={s.details}>
              <CompanyDetails company={company} />
            </div>
          ))}
        </>
      )}
    </section>
  )
}

export default LinkedCompanySection
